
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { initClient } from '../../../api';
import { LinkCollection, LinksApiUiClient } from '../../backend/backendapi';
import LinkCollectionStore from '../../../stores/LinkCollectionStore';

@Component
export default class CollectionDeleteModal extends Vue {
  private readonly api = initClient(LinksApiUiClient);
  private readonly store = new LinkCollectionStore();
  
  collections: LinkCollection[] = [];

  public open(collections: LinkCollection[]): void {
    this.collections = collections;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  async deleteSelected(): Promise<void> {
    if (!this.collections.length) {
      return;
    }
    let deleted = 0;
    for (let collection of this.collections) {
      try {
        await this.api.delete(collection.id);
        this.store.forgetCollection(collection);
      } catch (e) {
        this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(e));
      }
    }
    if (deleted > 0) {
      this.$toasted.info(this.$t('txtDeleted').toString());
    }
    this.$emit('deleted');
    this.dismiss();
  }
}
